import React, { Component } from "react";
import { Grid, Row, Col, Thumbnail } from "react-bootstrap";
import "./OtherProjects.css";
import config from "../config.projects";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Slider from "react-slick";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default class OtherProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      project: null,
      photoIndex: 0,
    };
  }
  renderProject(project, index) {
    const { base, imgs, title, customer } = project;
    return (
      <Col lg={4} md={6} key={index}>
        {" "}
        <Thumbnail
          src={base + imgs[0]}
          alt={title}
          onClick={(evt) => {
            this.setState({
              isOpen: true,
              project: project,
              photoIndex: 0,
            });
          }}
        >
          <h4>
            <span className="thumbnail-label">OBRA:</span> {title}
          </h4>
          <h4>
            <span className="thumbnail-label">Mandante:</span> {customer}
          </h4>
        </Thumbnail>
      </Col>
    );
  }
  renderOther(project, index) {
    const { title, customer } = project;
    return (
      <Col lg={6} md={6} key={index}>
        <h4>{title}</h4>
        <p>{customer}</p>
        <hr />
      </Col>
    );
  }
  render() {
    const { isOpen, project, photoIndex } = this.state;
    const images = project && project.imgs ? project.imgs : [];
    return (
      <div className="Projects">
        <Grid>
          <Row>
            <Col md={12}>
              <h3 className="title title-others-projects">
                Proyectos <b>Destacados</b>
              </h3>
            </Col>
          </Row>
          <Row className="others-projects">
            <Col md={7}>
              <p>
                <b>PizarroVial</b> amplia gama de proyectos y construcciones, en las que nos hemos esforzado para
                brindar <b>los mejores resultados.</b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Row className="others-container">
                {config.others.map((project, index) => {
                  return this.renderOther(project, index);
                })}
              </Row>
            </Col>
          </Row>
          {isOpen && (
            <Lightbox
              imageTitle={project.title}
              mainSrc={project.base + images[photoIndex]}
              nextSrc={project.base + images[(photoIndex + 1) % images.length]}
              prevSrc={
                project.base +
                images[(photoIndex + images.length - 1) % images.length]
              }
              onCloseRequest={() =>
                this.setState({ isOpen: false, project: null, photoIndex: 0 })
              }
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + images.length - 1) % images.length,
                })
              }
              onMoveNextRequest={() =>
                this.setState({ photoIndex: (photoIndex + 1) % images.length })
              }
            />
          )}
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/OtherProjects.js